// Lightweight cookie/storage consent helper.
// All non-essential tracking should be gated on hasConsent('analytics' | 'marketing').

export type ConsentCategory = "essential" | "analytics" | "marketing";

export interface ConsentState {
  version: number;
  decided_at: string; // ISO timestamp
  essential: true;
  analytics: boolean;
  marketing: boolean;
}

const KEY = "rt:cookie-consent:v1";
const VERSION = 1;

export function getConsent(): ConsentState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ConsentState;
    if (parsed.version !== VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setConsent(input: { analytics: boolean; marketing: boolean }) {
  if (typeof window === "undefined") return;
  const state: ConsentState = {
    version: VERSION,
    decided_at: new Date().toISOString(),
    essential: true,
    analytics: input.analytics,
    marketing: input.marketing,
  };
  localStorage.setItem(KEY, JSON.stringify(state));
  window.dispatchEvent(new CustomEvent("rt-consent-change", { detail: state }));
}

export function clearConsent() {
  if (typeof window === "undefined") return;
  localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent("rt-consent-change", { detail: null }));
}

export function hasConsent(category: ConsentCategory): boolean {
  if (category === "essential") return true;
  const c = getConsent();
  return !!c && !!c[category];
}

export function openCookiePreferences() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("rt-open-cookie-preferences"));
}
